/**
 * 🚪 **인앱 브라우저에서 기본 브라우저로 나가는 길** — 말과 단추를 한 곳에서(2026-10-08).
 *
 * ## 🔴 왜
 * 카메라 AR·랠리 위치·화상 무대가 각자 「**오른쪽 위** 메뉴에서 "다른 브라우저로 열기"」를 박아 두고 있었다(세 벌).
 * 그 말은 **안드로이드 카카오톡** 모양이다. 아이폰 카카오톡은 메뉴(⋯)가 아래쪽에 있고 항목도 「Safari로 열기」라서,
 * 보호자는 오른쪽 위에서 **없는 단추**를 찾게 된다(관찰 테스트·10. 17. 시연의 「카톡 대체 경로」 장면이 그 자리다).
 * 아이폰 쪽은 실기기로 확인하기 전이라 **위치를 단정하지 않는다**.
 *
 * 그리고 카카오톡은 외부 브라우저로 여는 주소(`kakaotalk://web/openExternal?url=`)를 연다 — 메뉴를 찾을 필요 없이
 * **단추 하나**로 나갈 수 있다. 다른 앱은 그런 주소가 없어 말로만 안내한다(없는 단추를 만들지 않는다).
 */

export type InAppOs = "ios" | "android" | "other";

/** 메뉴에서 무엇을 누르라고 할지 — 기기마다 자리·이름이 다르다. */
export function inAppMenuSay(os: InAppOs): string {
  if (os === "ios") return "메뉴(⋯)에서 「Safari로 열기」를 눌러 주세요";
  if (os === "android") return "오른쪽 위 메뉴(⋮)에서 「다른 브라우저로 열기」를 눌러 주세요";
  return "메뉴에서 「다른 브라우저로 열기」(아이폰은 「Safari로 열기」)를 눌러 주세요";
}

/**
 * 누르면 바로 기본 브라우저로 여는 주소. 그런 길이 없는 앱이면 `null` — 단추를 띄우지 않는다.
 * @param appName `platform.inAppName`(표시 이름) — 카카오톡만 지원한다
 * @param pageUrl 지금 주소(그대로 다시 연다). http(s) 가 아니면 `null`(엉뚱한 곳으로 내보내지 않는다)
 */
export function inAppEscapeUrl(appName: string | undefined, pageUrl: string): string | null {
  if (appName !== "카카오톡") return null;
  if (!/^https?:\/\//i.test(pageUrl)) return null;
  return `kakaotalk://web/openExternal?url=${encodeURIComponent(pageUrl)}`;
}
